import { createStore } from 'react-hookstore';

export const fullScreenModeStore = createStore('fullScreenMode', false);
